import { FC } from 'react';
import AuthComponents from './AuthComponents';
import GuideComponents from './GuideComponents';
import { useLoginContext } from '../LoginProvider';

const UserValidaition: FC = () => {
  const {
    state: { currentPageIndex, selectedBrokerConfig },
  } = useLoginContext();

  switch (currentPageIndex) {
    case 1:
      return <AuthComponents />;
    case 2:
      if (selectedBrokerConfig) {
        return <GuideComponents broker={selectedBrokerConfig.id} />;
      }
      return <div>No Tutorial Found !!!</div>;

    default:
      return null;
  }
};

export default UserValidaition;
